import styled from 'styled-components'

import DatePicker from 'react-datepicker'

export const DateTimeInput = ({
  value,
  onChange,
  dateFormat,
  showMonthYearPicker,
  title,
  wrapperClass,
  subText,
  showYearDropdown = false,
  scrollableYearDropdown = false,
  readOnly = false,
}) => {
  return (
    <StyledDateTimeInput className={wrapperClass}>
      <label>{title}</label>
      <DatePicker
        readOnly={readOnly}
        selected={value}
        onChange={onChange}
        dateFormat={dateFormat}
        showMonthYearPicker={showMonthYearPicker}
        showYearDropdown={showYearDropdown}
        scrollableYearDropdown={scrollableYearDropdown}
      />
      <sub style={{ color: 'red' }}>{subText}</sub>
    </StyledDateTimeInput>
  )
}

const StyledDateTimeInput = styled.div`
  width: 100%;

  &.error {
    .react-datepicker-wrapper .react-datepicker__input-container input {
      border-color: red;
    }

    label {
      color: red;
    }
  }

  .react-datepicker-wrapper {
    display: block;
    width: 100%;

    .react-datepicker__input-container {
      width: 100%;

      input {
        width: 100%;
        height: 2.5rem;
        border-radius: 3px;
        border: 1px solid #aeb3c9;
        padding: 0 1rem;
        outline: none;
      }
    }
  }

  label {
    font-size: 0.875rem;
    font-weight: 300;
  }
`
